<template>
  <div>
    <div class="w-100 px-5 py-4">
      <div slot="title">
        <h1>Verificación y entrega del token de la audiencia</h1>
        <h3>{{audiencia != undefined && audiencia != null ? audiencia.TipoDocumento.Nombre : "Cargando audiencia"}} {{audiencia != undefined ? audiencia.Consecutivo : ""}}</h3>
      </div>
      <div class="row padding-div-low">
        <div class="col-12 col-sm-12 col-md-12 col-lg-3">
          <div class="area">
            <h2>Información</h2>
            <hr />
            <p><strong>Juzgado: </strong>{{audiencia != undefined && audiencia != null ? audiencia.Area.Nombre : "Sin información"}}</p>
            <p><strong>Materia: </strong>{{audiencia != undefined && audiencia != null ? audiencia.Materia.Nombre : "Sin información"}}</p>
            <p><strong>Tipo de audiencia: </strong>{{audiencia != undefined && audiencia != null ? audiencia.TipoAudiencia.Nombre : "Sin información"}}</p>
            <p v-html="obtenFechaDeAudienciaConFormato(audiencia != undefined && audiencia != null ? audiencia.FechaAudiencia : '')"></p>
            <p v-html="obtenHoraDeAudienciaConFormato(audiencia != undefined && audiencia != null ? audiencia.Duracion : '')"></p>
            <p v-if="audiencia != undefined && audiencia != null">
              <strong>Jueces: </strong>
              <ul v-if="audiencia.JuecesEnAudiencia.length > 0">
                <li v-for="juezEnAudiencia in audiencia.JuecesEnAudiencia">
                  {{juezEnAudiencia.Juez.Nombre}}{{juezEnAudiencia.Juez.ApellidoPaterno != "" ? " " + juezEnAudiencia.Juez.ApellidoPaterno : ""}}{{juezEnAudiencia.Juez.ApellidoMaterno != "" ? " " + juezEnAudiencia.Juez.ApellidoMaterno : ""}}
                </li>
              </ul>
              <span v-else>Sin jueces</span>
            </p>
            <p><strong>Estatus de la audiencia: </strong>{{audiencia != undefined && audiencia != null ? audiencia.TipoEstatusDeAudiencia.Nombre : "Sin información"}}</p>
          </div>
        </div>
        <div v-if="audiencia != undefined && audiencia != null" class="col-12 col-sm-12 col-md-12 col-lg-9">
          <div class="area">
            <h4>Personas autorizadas</h4>
            <h6>Ingrese los datos de la persona que recoge los token y seleccione por que personas</h6>
            <hr />
            <div class="row">
              <div class="form-group col-md-12">
                <label for="seLeEntregaAUsuarioDeLaLista">¿A quien se le entregara?</label>
                <select class="form-control" id="seLeEntregaAUsuarioDeLaLista" v-model="opcionDePersonaQueRecoge" v-on:change="ajustaLaPersonaASeleccionar(opcionDePersonaQueRecoge)">
                  <option value="-1">Seleccione una persona</option>
                  <option v-for="permisoDeLaAudiencia in audiencia.PermisosDeLaAudiencia" v-model="permisoDeLaAudiencia.NombreCompleto" :key="permisoDeLaAudiencia.PermisoDeLaAudienciaId">{{permisoDeLaAudiencia.NombreCompleto}}</option>
                  <option value="-2">Otra persona viene por el token</option>
                </select>
              </div>
              <div class="form-group col-md-12" v-if="opcionDePersonaQueRecoge == -2">
                <label for="seLeEntregaAOtraPersona">Nombre de la persona</label>
                <input type="text" id="seLeEntregaAOtraPersona" class="form-control" v-model="personaALaQueSeEntrega.NombreCompleto" placeholder="Persona que se le entrega el token">
              </div>
              <div class="form-group col-md-6">
                <label for="grabacion_Receso">Tipo de identificación</label>
                <C038TiposIdentificacion v-on:valorParaElPadre="cambioDeTipoDeIdentificacion" :prefijo="enumeraciones.etiquetasDeHTML.Select" :tipo="enumeraciones.tiposDeSelect.Seleccione" :idDelInput="'tipoIdentificacion'" :parametros="{}" :valorDefinido="-1" :key="personaALaQueSeEntrega.TipoIdentificacion.TipoIdentificacionId"></C038TiposIdentificacion>
              </div>
              <div class="form-group col-md-6">
                <label for="grabacion_Receso">Folio de la identificación</label>
                <input type="text" class="form-control" v-model="personaALaQueSeEntrega.FolioDeLaIdentificacion" placeholder="Persona que se le entrega el token">
              </div>
            </div>
            <div id="PanelDePersonas_table" class="table-responsive">
              <table class="table table-striped table-light table-hover">
                <thead class="thead-dark">
                  <tr>
                    <th class="text-center">
                      <input type="checkbox" v-on:click="marcaODesmarcaTodo($event)" v-model="seleccionarTodos" />
                    </th>
                    <th >Persona a entregar</th>
                    <th >A quienes se entrego</th>
                  </tr>
                </thead>
                <tbody class="text-dark">
                  <tr v-if="audiencia.PermisosDeLaAudiencia.length <= 0">
                    <td colspan="5" class="text-center">No existen registros de personas</td>
                  </tr>
                  <tr v-else v-for="permisoDeLaAudiencia in audiencia.PermisosDeLaAudiencia" :key="permisoDeLaAudiencia.PermisoDeLaAudienciaId">
                    <td class="text-center">
                      <input type="checkbox" :id="permisoDeLaAudiencia.PermisoDeLaAudienciaId" v-model="permisoDeLaAudiencia.EstaSeleccionado" v-on:click="obtenYGuardaElIdDelPermiso(permisoDeLaAudiencia.PermisoDeLaAudienciaId, $event)" />
                    </td>
                    <td>{{permisoDeLaAudiencia.NombreCompleto}}</td>
                    <td>
                      <span v-if="permisoDeLaAudiencia.PersonasQueRecogieronElToken.length <= 0">No ha sido entregado.</span>
                      <span v-else v-for="(personaQueRecogioElToken, indice) in permisoDeLaAudiencia.PersonasQueRecogieronElToken" v-html="obtenPersonasALasQueSeLesEntregoFormato(indice, personaQueRecogioElToken)"></span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="justify-content-end text-right">
              <button class="btn btn-primary mb-2" v-on:click="guardarLaPersonaQueRecogioElToken()">
                <i class="fas fa-save"></i>&nbsp;&nbsp;Guarda y genera el documento
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import sistemas from '@/../static/js/sistemas';
  import enumeraciones from '@/../static/js/enumeraciones'
  import catalogos from '@/../static/js/catalogos'
  import api from '@/../static/js/api'
  import comun from '@/../static/js/comun'
  import router from '@/router/index'
  import axios from 'axios'

  export default {
    components: {
      enumeraciones,
      C038TiposIdentificacion: catalogos.PJ.C038TiposIdentificacion
    },
    data() {
      return {
        enumeraciones,
        audiencia: null,
        seleccionarTodos: false,
        opcionDePersonaQueRecoge: -1,
        personaALaQueSeEntrega: {
          NombreCompleto: null,
          TipoIdentificacion: {
            TipoIdentificacionId: -1
          },
          FolioDeLaIdentificacion: null
        },
        permisosDeLaAudienciaIds: []
      }
    },
    props: {
      AudienciaId: Number
    },
    mounted() {
      this.obtenAudiencia();
    },
    methods: {
      obtenFechaDeAudienciaConFormato: function(fechaDeAudiencia) {
        if(fechaDeAudiencia != "")
          return moment(fechaDeAudiencia).locale('es').format("[<strong>Fecha y hora: </strong>]DD [de] MMMM [del] YYYY [a las] h:mm a");
        else
          return "<strong>Fecha y hora: </strong>Sin información";
      },
      obtenFechaDeEntregaConFormato: function(fechaDeEntrega) {
        return moment(fechaDeEntrega).format("DD-MM-YYYY [a las] h:mm a")
      },
      obtenHoraDeAudienciaConFormato: function(horaDeAudiencia) {
        if(horaDeAudiencia != "")
          return moment(horaDeAudiencia, "HH:mm:ss").locale('es').format("[<strong>Duración: </strong>]h:mm [hora(s)]");
        else
          return "<strong>Duración: </strong>Sin información";
      },
      obtenPersonasALasQueSeLesEntregoFormato: function(indice, parametro) {
        return "" + (indice + 1) + ".- " + parametro.NombreCompleto + " presento su " + parametro.TipoIdentificacion.Nombre + " con Folio " + parametro.FolioDeLaIdentificacion  + ", el día " + this.obtenFechaDeEntregaConFormato(parametro.FechaDeEntrega) + " " + this.crearLaDescargaDelArchivo(parametro.RutaDelArchivoDelToken) + "<br />";
      },
      crearLaDescargaDelArchivo: function(rutaDelArchivo){
        return '<a href="' + api.conexion + api.Comun.funcion.DescargarArchivo + '?rutaDelArchivo=' + rutaDelArchivo + '" target="_blank" title="Descarga el archivo del token."><i class="fas fa-file-download"></i></a>';
      },
      obtenAudiencia: function() {
        comun.SeEstaCargandoInformacion(true);
        const parametros = {
          AudienciaId: this.AudienciaId,
          EsPrueba: this.enumeraciones.EsPrueba
        };

        axios.post(
          api.conexion + api.Forseti.sistema.administracion.entregadetoken.GetAudiencia,
          parametros,
          comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
          ).then(respuesta => {
            if(respuesta.data.SiHayError){
              console.log(respuesta);
              this.audiencia = null;
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
              this.$store.dispatch('A_ReglasDeRuteo', { aDondeSeRuteaOElError: respuesta.data.Error.MensajeId });
            } else {
              this.audiencia = respuesta.data.Audiencia;
            }
            comun.SeEstaCargandoInformacion(false);
          }
          ).catch(excepcion => {
            console.log(excepcion);
            this.audiencia = null;
            comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
            comun.SeEstaCargandoInformacion(false);
            router.push({ name: "EntregaDeToken" });
          });
      },
      ajustaLaPersonaASeleccionar: function(valorDeLaOpcion) {
        if(valorDeLaOpcion != -1 && valorDeLaOpcion != -2)
          this.personaALaQueSeEntrega.NombreCompleto = valorDeLaOpcion;
        else
          this.personaALaQueSeEntrega.NombreCompleto = null;
      },
      cambioDeTipoDeIdentificacion: function(datos) {
        this.personaALaQueSeEntrega.TipoIdentificacion.TipoIdentificacionId = datos.target.value;
      },
      marcaODesmarcaTodo: function(evento) {
        this.audiencia.PermisosDeLaAudiencia.forEach((parametro, index) => {
          if (evento.target.checked) {
            this.ingresarElPermisoDeLaAudiencia(parametro.PermisoDeLaAudienciaId);
          } else {
            this.eliminarElPermisoDeLaAudiencia(parametro.PermisoDeLaAudienciaId);
          }

          parametro.EstaSeleccionado = evento.target.checked;
        })
        this.verificaSiTodoEstaMarcadoONo();
      },
      verificaSiTodoEstaMarcadoONo: function() {
        if(this.audiencia.PermisosDeLaAudiencia.length == this.permisosDeLaAudienciaIds.length) {
          this.seleccionarTodos = true;
        } else {
          this.seleccionarTodos = false;
        }
      },
      obtenYGuardaElIdDelPermiso: function(dato, evento) {
        if (evento.target.checked) {
          this.ingresarElPermisoDeLaAudiencia(dato);
        } else {
          this.eliminarElPermisoDeLaAudiencia(dato);
        }

        this.verificaSiTodoEstaMarcadoONo();
      },
      ingresarElPermisoDeLaAudiencia: function(dato) {
        let fueEncontrado = false;
        this.permisosDeLaAudienciaIds.forEach(function(valorActual) {
          if(dato == valorActual)
            fueEncontrado = true;
        })

        if(!fueEncontrado)
          this.permisosDeLaAudienciaIds.push(dato);
      },
      eliminarElPermisoDeLaAudiencia: function(dato) {
        let indiceACortar = this.permisosDeLaAudienciaIds.indexOf(dato);

        if (indiceACortar > -1) 
          this.permisosDeLaAudienciaIds.splice(indiceACortar, 1)
      },
      validaLaPersonaQueRecogioElToken: function() {
        if(this.personaALaQueSeEntrega.NombreCompleto == null) {
          comun.mensajeDeAlerta("Seleccione o ingrese el nombre de la persona que va a recoger el token.", null, null);
          return false;
        }

        if(this.personaALaQueSeEntrega.TipoIdentificacion.TipoIdentificacionId == null || this.personaALaQueSeEntrega.TipoIdentificacion.TipoIdentificacionId == undefined) {
          comun.mensajeDeAlerta("Seleccione el tipo de identificación.", null, null);
          return false;
        }

        if(this.personaALaQueSeEntrega.FolioDeLaIdentificacion == null) {
          comun.mensajeDeAlerta("Ingrese el folio de la identificación.", null, null);
          return false;
        }

        if(this.permisosDeLaAudienciaIds.length <= 0) {
          comun.mensajeDeAlerta("Seleccione mínimo a una persona de la que se entregara su token.", null, null);
          return false;
        }

        return true;
      },
      guardarLaPersonaQueRecogioElToken: function() {
        if(this.validaLaPersonaQueRecogioElToken()) {
          comun.SeEstaCargandoInformacion(true);

          let parametros = {
            PermisosDeLaAudienciaIds: this.permisosDeLaAudienciaIds,
            PersonaQueRecogioElToken: this.personaALaQueSeEntrega,
            EsPrueba: this.enumeraciones.EsPrueba
          }

          axios.post(
            api.conexion + api.Forseti.sistema.administracion.entregadetoken.GuardaLaPersonaQueRecogioElToken,
            parametros,
            comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
            ).then(respuesta => {
              if(respuesta.data.SiHayError){
                console.log(respuesta);
                comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                this.$store.dispatch('A_ReglasDeRuteo', { aDondeSeRuteaOElError: respuesta.data.Error.MensajeId });
                comun.SeEstaCargandoInformacion(false);
              } else {
                respuesta.data.RutasDeLosArchivosDelToken.forEach(function(parametro, index) {
                  window.open(api.conexion + api.Comun.funcion.DescargarArchivo + '?rutaDelArchivo=' + parametro, '_blank');
                })
                comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
                this.obtenAudiencia();
                this.limpiarLaVentana()
              }
            }
            ).catch(excepcion => {
              console.log(excepcion);
              comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
              comun.SeEstaCargandoInformacion(false);
            });
        }
      },
      limpiarLaVentana: function() {
        this.opcionDePersonaQueRecoge = -1;
        this.personaALaQueSeEntrega = {
          NombreCompleto: null,
          TipoIdentificacion: {
            TipoIdentificacionId: -1
          },
          FolioDeLaIdentificacion: null
        };
        this.permisosDeLaAudienciaIds = [];
        $('input:checkbox').removeAttr('checked');
      }
    }
  }
</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// src/components/Forseti/Administracion/EntregaDeToken/VerificacionYEntregaDeToken.vue